import { defineRecipe } from "@chakra-ui/react"

export const linkRecipe = defineRecipe({
  base: {
    _hover: {
      "& button": {
        textDecoration: "none",
      },
      backgroundSize: "100% 1px",
      textDecoration: "none",
    },
    alignItems: "center",
    backgroundImage: "linear-gradient(currentColor, currentColor)",
    backgroundPosition: "0 100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "0% 1px",
    borderRadius: "l1",
    cursor: "pointer",
    display: "inline-flex",
    focusRing: "outside",
    gap: "1.5",
    outline: "none",
    outlineColor: "primary.400",
    py: "2px",
    transition:
      "color 180ms ease, background-size 300ms cubic-bezier(.2,.7,.2,1)",
  },
  className: "chakra-link",
  defaultVariants: {
    variant: "plain",
  },
  variants: {
    variant: {
      plain: {
        color: "colorPalette.fg",
      },
      underline: {
        color: "colorPalette.fg",
        textDecoration: "underline",
        textDecorationColor: "currentColor/20",
        textUnderlineOffset: "3px",
      },
    },
  },
})
